// awsconfig.ts
import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-1_iKpGxRjjD',
      userPoolClientId: '1u4fveakbeeqcf2gjdbp6vcp1v',
      identityPoolId: 'ap-northeast-1:bde6ebae-51a1-43bd-ac46-ce83d3e0571b', // Optional
    },
    loginWith: {
      username: true,
      email: true,
      phone: false,
    },
  },
   API: {
    REST: {
       'vpp_flex_retail_eq-api-prd': {
        endpoint: 'https://t518zridue.execute-api.ap-northeast-1.amazonaws.com/v1/eq',
        region: 'ap-northeast-1',
      },
    },
  },
};

export default awsConfig;
